import angular from 'angular';
import { FacebookCallbackController } from './FacebookCallbackController';
import FacebookCallbackView from './FacebookCallbackView.html';
export default angular
    .module('facebook', [])
    .config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('facebookCallback', {
        url: '/facebookCallback',
        controller: FacebookCallbackController,
        controllerAs: '$ctrl',
        template: FacebookCallbackView,
    });
})
    .name;
